import React from "react";
import { injectIntl, FormattedMessage } from "react-intl";
import CopyrightLink from "./copyright-link";
import withStyles from "components/with-styles";
import styles from "./styles/copyright-content.css.js";
import { isMobileOnly } from "react-device-detect";
import { useCustomThemeContext } from "components/mui-providers";
import packageJson from "../../package.json";

const CopyrightContent = ({ classes, intl }) => {
  const {
    customTheme: { footerData },
  } = useCustomThemeContext();

  const copyrightText = intl.formatMessage(
    { id: "app.copyright" },
    {
      currentYear: new Date().getFullYear(),
      appOwner: footerData.copyrightName,
        appVersion: packageJson.version,
    },
  );

  return (
    <>
      {!isMobileOnly && <p className={classes.copyrightText}>{copyrightText}</p>}
      <p>
        <CopyrightLink url={footerData.privacyPolicy}>
          <FormattedMessage id="app.privacy" />
        </CopyrightLink>
        <CopyrightLink url={footerData.useTerms}>
          <FormattedMessage id="app.terms" />
        </CopyrightLink>
      </p>
    </>
  );
};

export default withStyles(styles)(injectIntl(CopyrightContent));
